import { db } from '../config/firebase';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';

export const glossaryService = {
  // Get all glossary terms
  getAllTerms: async () => {
    try {
      const termsRef = collection(db, 'glossary');
      const termsQuery = query(termsRef, orderBy('term', 'asc'));
      const termsSnap = await getDocs(termsQuery);
      const terms = [];

      termsSnap.forEach((doc) => {
        terms.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      return { terms, error: null };
    } catch (error) {
      console.error('Error fetching glossary terms:', error);
      return { terms: [], error: error.message };
    }
  },

  // Get a single term
  getTerm: async (termId) => {
    try {
      const termRef = doc(db, 'glossary', termId);
      const termSnap = await getDoc(termRef);

      if (!termSnap.exists()) {
        return { term: null, error: 'Term not found' };
      }

      return {
        term: {
          id: termSnap.id,
          ...termSnap.data(),
        },
        error: null,
      };
    } catch (error) {
      console.error('Error fetching term:', error);
      return { term: null, error: error.message };
    }
  },

  // Create new term
  createTerm: async (termData) => {
    try {
      const termsRef = collection(db, 'glossary');
      const docRef = await addDoc(termsRef, {
        ...termData,
        createdAt: new Date(),
        updatedAt: new Date(),
      });

      return { success: true, termId: docRef.id, error: null };
    } catch (error) {
      console.error('Error creating term:', error);
      return { success: false, error: error.message };
    }
  },

  // Update term
  updateTerm: async (termId, updates) => {
    try {
      const termRef = doc(db, 'glossary', termId);
      await updateDoc(termRef, {
        ...updates,
        updatedAt: new Date(),
      });

      return { success: true, error: null };
    } catch (error) {
      console.error('Error updating term:', error);
      return { success: false, error: error.message };
    }
  },

  // Delete term
  deleteTerm: async (termId) => {
    try {
      const termRef = doc(db, 'glossary', termId);
      await deleteDoc(termRef);

      return { success: true, error: null };
    } catch (error) {
      console.error('Error deleting term:', error);
      return { success: false, error: error.message };
    }
  },
};

export default glossaryService;

